<script setup lang="ts">
import IconButton from "@/components/ui/IconButton/IconButton.vue";

defineProps<{ title: string; triggerId?: string }>();
const emit = defineEmits<{ open: [] }>();
</script>

<template>
  <div class="actions">
    <span class="title">{{ title }}</span>
    <IconButton
      :id="triggerId"
      class="open-full-view"
      icon="general/open-dialog"
      size="small"
      :text="$t('sightline.openFullView')"
      @click="emit('open')"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .title {
    @include typography.medium("bold");

    flex: 1;
    color: colors.$text-subtle;
  }

  .open-full-view {
    opacity: var(--sightline-expand-opacity, 0);
  }

  @media (hover: none) {
    .open-full-view {
      opacity: 1;
    }
  }
}
</style>
